import React, { useState } from 'react';
import Loading from "./Loading";
import { Modal, Button } from 'flowbite-react'; // Import necessary components
import ReactHtmlParser from 'react-html-parser';

const EditRfqWarningPopUp = ({
    openModal,
    handleClosePopup,
    handleSubmit,
    loading = false,
    notifyVendors,
    setNotifyVendors,
    submitForm,
    actionType,
    isSupplierInvited
}) => {
    const [showError, setShowError] = useState(false); // Error state to manage visibility of the error message


    const warningText =
  actionType === "cancel"
    ? "Are you sure you want to cancel? Unsaved changes will be lost."
    : `Changes may impact the Vendor Quotation, are you sure you want to update RFQ ?<br /><br />${isSupplierInvited ? "Select one of the option below based on your changes, if any vendor action is required:" : ""}`;



    const handleRadioChange = (e) => {
        const selectedValue = e.target.value === 'true'; // true means "Update, and notify vendors"
        setNotifyVendors(selectedValue);  // Update parent state
        setShowError(false); // Hide error message when a value is selected
    };

    const handleFormSubmit = () => {
        if (actionType === "update") {
            if (notifyVendors === null && isSupplierInvited) {
                setShowError(true); // Show error if no radio button is selected
                return;
            }
            submitForm(); // Proceed with submission
        } else {
            handleClosePopup()
        }

    };

    return (
        <div>
            <Modal show={openModal} size="lg" onClose={handleClosePopup} popup>
                <Modal.Header className="-mb-6"></Modal.Header>
                <Modal.Body>
                    <div className="">
                        <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            className="mx-auto mb-4 h-10 w-10 text-red-500 dark:text-red-200"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                        </svg>

                        <h4 className="mb-2  font-normal text-gray-600 dark:text-gray-400">
                            {ReactHtmlParser(warningText)}
                        </h4>

                    </div>


                    {/* Radio Buttons for selection */}
                    {actionType === "update" && isSupplierInvited && <div className="mb-4 mt-4">
                        <div><label className="cursor-pointer text-gray-800">
                            <input
                                type="radio"
                                name="updateOption"
                                value="true"
                                checked={notifyVendors === true}
                                onChange={handleRadioChange}
                                className="form-radio cursor-pointer"
                            />
                            <span className="ml-2">Notify Vendor of Changes</span>
                        </label> </div>

                        <div className="mt-1">
                            <label className="cursor-pointer text-gray-800">
                                <input
                                    type="radio"
                                    name="updateOption"
                                    value="false"
                                    checked={notifyVendors === false}
                                    onChange={handleRadioChange}
                                    className="form-radio cursor-pointer"
                                />
                                <span className="ml-2">Do Not Notify Vendor of Changes</span>
                            </label>
                        </div>

                        {/* Error message if no radio button is selected */}
                        {showError && (
                            <div className="text-red-500 text-sm absolute mt-2">Please select an option.</div>
                        )}
                    </div>}



                    <div className="flex justify-end gap-4">
                        {/* <Button color="gray" onClick={handleClosePopup}>
              No, cancel
            </Button> */}
                        <Button color="blue" onClick={handleFormSubmit} className='p-0'>
                            {loading ? <Loading /> : "Yes, I'm sure"}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default EditRfqWarningPopUp;
